import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OffersGroupReportComponent } from '../reports/offers-group-report/offers-group-report.component';
import { OffersReportComponent } from '../reports/offers-report/offers-report.component';
import { MeetingGroupReportComponent } from '../reports/meeting-group-report/meeting-group-report.component';
import { MeetingReportComponent } from '../reports/meeting-report/meeting-report.component';
import { CombinedGroupReportComponent } from '../reports/combined-group-report/combined-group-report.component';
import { RecommendationGroupReportComponent } from '../reports/recommendation-group-report/recommendation-group-report.component';


const routes: Routes = [
  {
    path: 'offers-group',
    component: OffersGroupReportComponent
  },
  {
    path: 'offers',
    component: OffersReportComponent
  },
  {
    path: 'meeting-group',
    component: MeetingGroupReportComponent
  },
  {
    path: 'meeting',
    component: MeetingReportComponent
  },
  {
    path: 'combined-group',
    component: CombinedGroupReportComponent
  },
  {
    path: 'recommendation-group',
    component: RecommendationGroupReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportPanelRoutingModule { }
